import React, { useState } from 'react';
import { CreditCardIcon, CoinsIcon, CheckCircleIcon } from 'lucide-react';
interface PaymentMethod {
  id: string;
  type: 'card' | 'credits';
  name: string;
  details: string;
  badge?: string;
}
interface PaymentMethodSelectorProps {
  onSelect: (methodId: string) => void;
  selectedId?: string;
}
export function PaymentMethodSelector({
  onSelect,
  selectedId = 'credits'
}: PaymentMethodSelectorProps) {
  const [selected, setSelected] = useState(selectedId);
  const methods: PaymentMethod[] = [{
    id: 'card',
    type: 'card',
    name: 'Credit / Debit Card',
    details: 'Visa •••• 1234'
  }, {
    id: 'credits',
    type: 'credits',
    name: 'UniPlay Credits',
    details: 'Balance: 500 UC (≈ $50)',
    badge: 'SAVE 5%'
  }];
  const handleSelect = (methodId: string) => {
    setSelected(methodId);
    onSelect(methodId);
  };
  return <div className="space-y-3" data-id="element-185">
      {methods.map(method => {
      const isSelected = selected === method.id;
      const Icon = method.type === 'card' ? CreditCardIcon : CoinsIcon;
      return <button key={method.id} onClick={() => handleSelect(method.id)} className={`w-full bg-white rounded-xl p-4 flex items-center gap-4 transition-all ${isSelected ? 'border-2 border-[#3dc7e3] shadow-lg' : 'border-2 border-gray-200 shadow-md'}`} data-id="element-186">
            {/* Icon */}
            <div className={`w-12 h-12 rounded-full flex items-center justify-center ${method.type === 'credits' ? 'bg-[#c7f61e]/20' : 'bg-gray-100'}`} data-id="element-187">
              <Icon className={`w-6 h-6 ${method.type === 'credits' ? 'text-[#c7f61e]' : 'text-[#666666]'}`} data-id="element-188" />
            </div>

            {/* Details */}
            <div className="flex-1 text-left" data-id="element-189">
              <div className="flex items-center gap-2 mb-1" data-id="element-190">
                <h4 className="text-base font-bold text-[#1f5070]" data-id="element-191">
                  {method.name}
                </h4>
                {method.badge && <span className="bg-[#c7f61e] text-[#1f5070] text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-192">
                    {method.badge}
                  </span>}
              </div>
              <p className="text-sm text-[#666666]" data-id="element-193">{method.details}</p>
            </div>

            {/* Radio/Check */}
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-[#3dc7e3] bg-[#3dc7e3]' : 'border-gray-300'}`} data-id="element-194">
              {isSelected && <CheckCircleIcon className="w-5 h-5 text-white" data-id="element-195" />}
            </div>
          </button>;
    })}
    </div>;
}